import React from 'react'
import PropTypes from 'prop-types'
import Parallax from 'react-rellax'

import './heroTypographic.css'

const HeroTypographic = ({ data }) => {
  const width = data.config && data.config.width ? data.config.width : 'normal'
  const textColor = data.config && data.config.textColor ? data.config.textColor : 'black'
  return (
    <Parallax as="section" speed={-2} className={`heroTypographic text-${textColor} ${width}`}>
      <div className="content ">
        <h1>{data.text}</h1>
      </div>
    </Parallax>
  )
}

HeroTypographic.propTypes = {
  data: PropTypes.object,
}
HeroTypographic.defaultProps = {
  data: {
    text: '',
  },
}

export default HeroTypographic
